import React, { useState, useEffect } from 'react';
import bunnyMoniLogo from '../assests/bunnyMoni.jpg';

const Return: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const redirectToApp = () => {
    setIsLoading(true);

    // Try different app schemes - redirect to add-funding-source to check connection status
    const appSchemes = [
      'hopsavings://add-funding-source',  // Direct to add funding source screen
      'hopsavings://dashboard',            // Fallback to dashboard
      'exp://localhost:8081',              // Expo development
      'exp://192.168.1.100:8081',         // Expo development (common IP)
    ];

    let currentScheme = 0;

    const tryNextScheme = () => {
      if (currentScheme >= appSchemes.length) {
        // If all schemes fail, show a message
        setIsLoading(false);
        return;
      }

      const scheme = appSchemes[currentScheme];
      console.log('Trying scheme:', scheme);

      // Try to open the app
      window.location.href = scheme;

      // If we're still here after 2 seconds, try the next scheme
      setTimeout(() => {
        currentScheme++;
        tryNextScheme();
      }, 2000);
    };

    // Start trying schemes
    tryNextScheme();
  };

  // Auto-redirect after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      redirectToApp();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      background: 'linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)',
      margin: 0,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      color: '#333333'
    }}>
      <div style={{
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.15)',
        padding: '2rem',
        borderRadius: '20px',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        width: '90%'
      }}>
        <div style={{
          marginBottom: '1.5rem'
        }}>
          <img
            src={bunnyMoniLogo}
            alt="HopSavings Logo"
            style={{
              width: '120px',
              height: '120px',
              marginBottom: '1rem'
            }}
          />
        </div>
        <h1 style={{
          margin: '0 0 0.5rem 0',
          fontSize: '1.8rem',
          fontWeight: 'bold'
        }}>
          HopSavings
        </h1>
        <h2 style={{
          margin: '0 0 1rem 0',
          fontSize: '1.2rem',
          fontWeight: 'normal',
          opacity: 0.9
        }}>
          Account Setup Complete!
        </h2>
        <p style={{
          margin: '0 0 2rem 0',
          opacity: 0.9,
          lineHeight: 1.5
        }}>
          Your bank account has been successfully connected. You can now start saving towards your goals.
        </p>

        {!isLoading && (
          <button
            onClick={redirectToApp}
            style={{
              background: 'rgba(109, 169, 215, 0.3)',
              border: '2px solid rgba(109, 169, 215, 0.5)',
              color: '#333333',
              padding: '12px 24px',
              borderRadius: '25px',
              textDecoration: 'none',
              display: 'inline-block',
              transition: 'all 0.3s ease',
              fontWeight: 600,
              cursor: 'pointer'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = 'rgba(109, 169, 215, 0.5)';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'rgba(109, 169, 215, 0.3)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Return to App
          </button>
        )}

        {isLoading && (
          <div style={{
            marginTop: '1rem'
          }}>
            <div style={{
              border: '2px solid rgba(109, 169, 215, 0.5)',
              borderTop: '2px solid #333333',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              animation: 'spin 1s linear infinite',
              margin: '0 auto'
            }}></div>
            <p>Redirecting...</p>
          </div>
        )}
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Return;
